import store from "~/js/store/store";
export default class HoverImage {
  constructor(contents) {
    if (!contents) {
      return;
    }
    this.image = contents.querySelectorAll(".c-card__image");
    this.setup();
  }

  setup() {
    if (store.getters["isSP"]()) {
      //SP
      this.image.forEach((elm, index) => {
        elm.addEventListener(
          "touchstart",
          (event) => {
            this.clear();
            elm.classList.add("hover");
          },
          {
            passive: true
          }
        );
      });
    }
  }

  clear() {
    this.image.forEach((elm, index) => {
      elm.classList.remove("hover");
    });
  }
}
